@let sensorBlock = sensorBlockItem();
@if (sensorBlock) {
  @if (embedded()) {
    <div class="chart-content" [nbSpinner]="loader() || seriesLoader()">
      <ng-container *ngTemplateOutlet="chartBody"></ng-container>
    </div>
  } @else {
    <nb-card [nbSpinner]="loader() || seriesLoader()">
      <nb-card-header>
        <button nbButton ghost status="primary" (click)="navigateBack()">
          <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
        </button>
        <div class="sensor-block-info">
          <div>{{sensorBlock.name}}</div>
          <div class="description">{{sensorBlock.description}}</div>
        </div>
      </nb-card-header>
      <nb-card-body>
        <ng-container *ngTemplateOutlet="chartBody"></ng-container>
      </nb-card-body>
    </nb-card>
  }

  <ng-template #chartBody>
    <div class="filter-panel">
      <div class="filter-row primary-row">
        <div class="filter-field">
          <span class="filter-label">Sensor</span>
          <nb-select placeholder="Sensor auswählen" [(ngModel)]="selectedSensorId" fullWidth>
            @for (sensor of sensorBlock.sensors; track sensor.id) {
              <nb-option [value]="sensor.id">
                {{sensor.name}} ({{sensor.effectiveUnit | sensorUnit}})
              </nb-option>
            }
          </nb-select>
        </div>
        <div class="filter-field">
          <span class="filter-label">Zeitraum</span>
          <wr-datetime-range-picker [(ngModel)]="dateRange"></wr-datetime-range-picker>
        </div>
        <div class="filter-field datapoint-stat">
          <span class="filter-label">Datenpunkte</span>
          <div class="stat-value">{{pointCount()}}</div>
        </div>
      </div>
      <div class="filter-row secondary-row">
        <div class="filter-field">
          <span class="filter-label">Quelle</span>
          <nb-select [(ngModel)]="source" fullWidth>
            <nb-option value="raw">RAW</nb-option>
            <nb-option value="cleaned">CLEANED</nb-option>
            <nb-option value="both">Beide</nb-option>
          </nb-select>
        </div>
        <div class="filter-field">
          <span class="filter-label">Aggregation</span>
          <wr-aggregation-interval-select [(ngModel)]="aggregationInterval"></wr-aggregation-interval-select>
        </div>
        <div class="filter-field">
          <span class="filter-label">Diagrammtyp</span>
          <nb-select [(ngModel)]="chartType" fullWidth>
            <nb-option value="scatter">Punktdiagramm</nb-option>
            <nb-option value="line">Liniengraf</nb-option>
            <nb-option value="line+points">Linie mit Punkten</nb-option>
            <nb-option value="bar">Balkendiagramm</nb-option>
          </nb-select>
        </div>
        <div class="filter-field checkbox-field">
          <nb-checkbox [(ngModel)]="showImputed">Berechnete Werte anzeigen</nb-checkbox>
        </div>
      </div>
    </div>
    @if (loadError(); as error) {
      <wr-banner status="danger"
                 [icon]="{ icon: 'alert-circle-outline', pack: 'eva' }"
                 [message]="error">
      </wr-banner>
    }
    @for (notice of notices(); track notice) {
      <wr-banner status="warning"
                 [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                 [message]="notice">
      </wr-banner>
    }
    <div class="chart-container">
      <plotly-plot #plot [data]="graph.data" [layout]="graph.layout" [config]="chartConfig" [style.visibility]="chartReady() ? 'visible' : 'hidden'" (initialized)="onPlotInit()"></plotly-plot>
    </div>
  </ng-template>
}
